/**
 * PolicyBadge — Tool policy badge (Auto / Approval / Forbidden)
 */

import { Check, AlertTriangle, X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { POLICY_LABELS, POLICY_COLORS, type ToolPolicy } from '@/lib/mock-studio-data';
import type { LucideIcon } from 'lucide-react';

const POLICY_ICONS: Record<ToolPolicy, LucideIcon> = {
  auto_approve: Check,
  require_approval: AlertTriangle,
  forbidden: X,
};

interface PolicyBadgeProps {
  policy: ToolPolicy;
  className?: string;
}

export function PolicyBadge({ policy, className }: PolicyBadgeProps) {
  const Icon = POLICY_ICONS[policy];
  return (
    <Badge variant="outline" className={cn('text-[9px]', POLICY_COLORS[policy], className)}>
      <Icon className="h-2.5 w-2.5 mr-0.5" />
      {POLICY_LABELS[policy]}
    </Badge>
  );
}
